// extracted by mini-css-extract-plugin
export default {"dataHeader":"finance_holdings-panel_dataHeader","holdingTable":"finance_holdings-panel_holdingTable"};